import React from "react";
import { IDMCActivity } from "commonFnBcode/types/dmc.types";
import { Alert } from "react-bootstrap";

interface ActivityInfoSectionProps {
  activity: IDMCActivity;
}

function ActivityInfoSection({ activity }: ActivityInfoSectionProps) {
  return (
    <div className="mb-4">
      <h5 className="text-primary border-bottom pb-2">
        <i className="fas fa-info-circle me-2"></i>
        Activity Information
      </h5>
      <div className="row">
        <div className="col-md-6">
          <div className="mb-3">
            <strong>Name:</strong>
            <p className="text-muted mb-1">{activity.name}</p>
          </div>
          <div className="mb-3">
            <strong>ID:</strong>
            <span className="badge bg-secondary ms-2">{activity.id}</span>
          </div>
        </div>
        <div className="col-md-6">
          {activity.priority && (
            <div className="mb-3">
              <strong>Priority:</strong>
              <span className="badge bg-info ms-2">{activity.priority}</span>
            </div>
          )}
          <div className="mb-3">
            <strong>Status:</strong>
            <span
              className={`badge ms-2 ${
                activity.isActive ? "bg-success" : "bg-secondary"
              }`}
            >
              {activity.isActive ? "Active" : "Inactive"}
            </span>
          </div>
        </div>
      </div>

      {activity.isTransferRequired && (
        <Alert variant="info" className="mb-3">
          <i className="fas fa-bus me-2"></i>
          Transfer is required for this activity
        </Alert>
      )}
    </div>
  );
}

export default ActivityInfoSection;
